import { BaseModel } from "../../../../../core/util/BaseModel";
import { SingleFormModel } from "../../../forms/singleFormModel/SingleForm_model";
import { GetChangePasswordFields } from "./ChangePassword_fields";

import ProgressIndicatorModel, {
  ProgressIndicatorModel as IProgressIndicatorModel
} from "../../../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import { observable, action, makeObservable } from "mobx";
import UsersApi, { UsersApi as IUsersApi } from "../../../../../services/api/v2/users/Users.api";
import ToasterService, { ToasterService as IToasterService } from "../../../../../core/toaster/ToasterService";
import { TOASTER_TOAST_TIME } from "../../../../../core/toaster/Toaster_model";
import I18n from "../../../../../core/localization/I18n";

export class SecuritySettingsModel extends BaseModel {
  formModel: SingleFormModel;
  usersProvider: IUsersApi;
  httpProgress: IProgressIndicatorModel;
  @observable errorMessage: string = "";
  organisationId: number;
  navigate: any;
  toasterService: IToasterService;
  /**
   *
   */
  constructor(organisationId: number, navigate) {
    super();
    makeObservable(this);
    this.navigate = navigate;
    this.formModel = new SingleFormModel();
    this.httpProgress = ProgressIndicatorModel;
    this.usersProvider = UsersApi;
    this.formModel.formFields = GetChangePasswordFields();
    this.organisationId = organisationId;
    this.toasterService = ToasterService;
  }

  @action
  resetErrorMessage = () => {
    this.errorMessage = "";
  };

  @action
  updatePassword = async () => {
    this.resetErrorMessage();
    let res = await this.formModel.submit();
    if (!res) return;
    this.httpProgress.showOverlay();
    let result = await this.usersProvider.setPassword(this.organisationId, res.currentPassword, res.newPassword);
    this.httpProgress.hideOverlay();
    if (!result.payload as any) {
      this.toasterService
        .showErrorToast(TOASTER_TOAST_TIME.NORMAL)
        .setContent(<p>{`${I18n.t("phrases.currentPasswordIncorrect")}`}</p>);
      this.formModel.resetFields();
    } else if (result && result.payload) {
      this.formModel.resetFields();
      this.toasterService
        .showSuccessToast(TOASTER_TOAST_TIME.NORMAL)
        .setContent(<p>{`${I18n.t("phrases.passwordChangedSuccessfully")}`}</p>);
    }
  };
}
